export const API_AUTH_PREFIX = '/auth';
export const API_USER_PREFIX = '/users';
export const API_FEEDBACK_REQUESTS_PREFIX = '/feedback-requests';
export const API_FEEDBACK_SUBJECTS_PREFIX = '/feedback-subjects';
export const API_USER_PROFILE_PREFIX = '/user-profiles';
export const API_USER_ROLE_PREFIX = '/user-roles';
export const API_ORGANIZATION_PREFIX = '/companies';
export const API_FILE_PREFIX = '/file-storage';
export const API_ORDER_PREFIX = '/orders';
export const API_REQUEST_PREFIX = '/requests';
export const API_PRODUCT_PREFIX = '/products';
export const API_PRODUCT_TYPES_PREFIX = '/product-types';
export const API_CATALOG_PREFIX = '/catalogs';
export const API_FEEDBACK_REQUEST_PREFIX = '/feedback-requests';
export const API_FEEDBACK_SUBJECT_PREFIX = '/feedback-subjects';
export const API_AVAILABLE_PRODUCT_PREFIX = '/available-products';
export const API_USER_PRODUCT_PREFIX = '/user-products';
export const API_USER_PROFILE_OPTION_PREFIX = '/user-profile-options';
export const API_FILE_NO_AUTH_PREFIX = '/file-storage/no-authentication';

// CRM
export const API_CRM_INTERESTS_PREFIX = '/crm-interests';
export const API_CRM_PRODUCTS_PREFIX = '/crm-products';
export const API_CRM_INTERESTS_SYNC_PREFIX = '/crm-interests/sync';
export const API_CRM_PRODUCTS_SYNC_PREFIX = '/crm-products/sync';
